import { useContext, useEffect } from 'react';
import { MiniCardGrafico } from './MiniCardGrafico';
import { useProtesisIniciadoAutorizadoTotales } from '../hooks';
import { ProtesisTramitesContext } from '../context';
import dayjs from 'dayjs';
import { GraficoLine } from './GraficoLine';
import { Grid } from '@mui/material';

export const IniciadoAutorizadoAnualLineaTotal = () => {
  const { anualList, anualDate } = useContext(ProtesisTramitesContext);
  const { dataAutorizadosAnual, getTramitesAnual } =
    useProtesisIniciadoAutorizadoTotales({
      anualList,
      anualDate,
    });

  useEffect(() => {
    if (anualList?.length > 0 && anualDate) {
      getTramitesAnual();
    }
  }, [anualList, anualDate]);

  return (
    <>
      <Grid item xs={12} sm={3}>
        <MiniCardGrafico
          total={dataAutorizadosAnual?.total || 0}
          title={
            <>
              <span>Autorizadas</span>
            </>
          }
          subtitle={dayjs(anualDate).format('YYYY')}
        >
          <GraficoLine
            labels={dataAutorizadosAnual?.labels || []}
            datasets={dataAutorizadosAnual?.datasets || []}
          />
        </MiniCardGrafico>
      </Grid>
    </>
  );
};
